import React, { useState } from "react";
import DrawerTitle from "../Drawer/DrawerTitle";
import OnlineAppointmentsSection from "./MyAppointment/OnlineAppointmentsSection";
import {
  AllTabType,
  IAppintentType,
  IqueryParams,
} from "src/types/GlobalInterfaces";
import InClinicAppointmentSection from "./MyAppointment/InClinicAppointmentSection";
import AtHomeAppointmentSection from "./MyAppointment/AtHomeAppointmentSection";
import { IPaginated } from "src/types/paginated";
import Cookies from "js-cookie";
import { customer, doctorMode } from "src/lib/constans";
import TabsButton from "./TabsButton";
import { useSelector } from "react-redux";
import { RootState } from "src/Store/store";
import TabsSlideContainer from "../GlobalComponents/Widget/TabsSlideContainer";
import InfinteScrollWrapper from "../GlobalComponents/Widget/InfinteScrollWrapper";

const MyAppointmentScreen = ({
  onBack,
  setActiveTab,
  onClose,
}: {
  onBack: () => void;
  setActiveTab: (tab: AllTabType) => void;
  onClose?: () => void;
}) => {
  const [acTab, setAcTab] = useState<string>("Online Appointments");
  const { allIndicators } = useSelector((state: RootState) => state.redDots);
  let tabs = [
    {
      name: "Online Appointments",
      count: allIndicators?.customerOnlineAppointment,
      active: acTab === "Online Appointments",
      setActiveTab: () => {
        setAcTab("Online Appointments");
      },
    },
    {
      name: "In-Clinic Appointments",
      count: allIndicators?.customerPhysicalAppointment,
      active: acTab === "In-Clinic Appointments",
      setActiveTab: () => {
        setAcTab("In-Clinic Appointments");
      },
    },
    {
      name: "At-Home Appointments",
      count: allIndicators?.customerHomeCareOrder,
      active: acTab === "At-Home Appointments",
      setActiveTab: () => {
        setAcTab("At-Home Appointments");
      },
    },
  ];

  const [mode] = useState(Cookies.get(doctorMode) || customer);
  const [isOnlineLoader, setIsOnlineLoader] = useState<boolean>(false);
  const [onlineData, setOnlineData] = useState<IAppintentType[]>([]);
  const [onlineQueryParams, setOnlineQueryParams] = useState<IqueryParams>({
    page: 1,
    limit: 10,
    role: mode,
    isOnline: true,
    startDate: "",
    endDate: "",
    status: "",
  });
  const [onlinePaginated, setOnlinePaginated] = useState<IPaginated>({
    currentPage: 1,
    totalPages: 1,
  });

  const handleChangeQuery = (data: Partial<IqueryParams>, reset = true) => {
    let q = {...onlineQueryParams , ...data}
    setOnlineQueryParams(q)
    if(reset) {
      setOnlineData([])
      q.page = 1
      setOnlinePaginated({
        currentPage: 1,
        totalPages: 1,
      })
    }
    setOnlineQueryParams(q)
  }

  const handleReset = () => {
    setOnlineQueryParams({
      page: 1,
      limit: 10,
      role: mode,
      isOnline: true,
      startDate: "",
      endDate: "",
      status: "",
    });

    setOnlinePaginated({
      currentPage: 1,
      totalPages: 1,
    });
    setOnlineData([]);
  };

  return (
    <>
      <DrawerTitle
        title={"My Appointment"}
        backBtn
        onBack={onBack}
        id="back-button"
      />
      {/* Navigation Tabs */}
      <div className="w-full flex flex-col side-bar-padding-3 side-bar-gap">
        <div className="flex gap-2 overflow-x-auto overflow-y-hidden scroll-hide">
          <TabsSlideContainer
            tabs={tabs}
            activeTab={tabs.find((tab) => tab.name === acTab) || tabs[0]}
            onChange={(tab) => {
              setAcTab(tab.name);
              handleReset();
            }}
          />
        </div>

        <InfinteScrollWrapper
          paddingBottom="pb-0"
          currentPage={onlineQueryParams?.page}
          onLoadMore={(page) => {
            handleChangeQuery({ page }, false);
          }}
          length={onlineData.length}
          totalPages={onlinePaginated?.totalPages}
          isLoading={isOnlineLoader}
          noDataOptions={{
            text2: "No Appointment Found",
          }}
        >
          {/* Doctor Cards */}
            {acTab === "Online Appointments" && (
              <OnlineAppointmentsSection
                isLoader={isOnlineLoader}
                setIsLoader={setIsOnlineLoader}
                setData={setOnlineData}
                data={onlineData}
                queryParams={onlineQueryParams}
                setPaginated={setOnlinePaginated}
                onClose={onClose || (() => {})}
              />
            )}
            {acTab === "In-Clinic Appointments" && (
              <InClinicAppointmentSection
                isLoader={isOnlineLoader}
                setIsLoader={setIsOnlineLoader}
                setData={setOnlineData}
                data={onlineData}
                queryParams={onlineQueryParams}
                setPaginated={setOnlinePaginated}
                onClose={onClose || (() => {})}
              />
            )}
            {acTab === "At-Home Appointments" && (
              <AtHomeAppointmentSection
                isLoader={isOnlineLoader}
                setIsLoader={setIsOnlineLoader}
                setData={setOnlineData}
                data={onlineData}
                queryParams={onlineQueryParams}
                setPaginated={setOnlinePaginated}
                onClose={onClose || (() => {})}
              />
            )}
        </InfinteScrollWrapper>
      </div>
    </>
  );
};

export default MyAppointmentScreen;
